import React from "react";
import { cn } from "../../../lib/utils";
import { FIELD, FIELD_INVALID } from "./classes";

/** Pill text input on the field fill (wireframes: every input is a rounded pill). */
const CrmInput = React.forwardRef(function CrmInput({ className, invalid, ...rest }, ref) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(FIELD, "", invalid && FIELD_INVALID, className)}
      {...rest}
    />
  );
});

export default CrmInput;
